// File: client/src/variants/power/index.js
// Power Chess as a platform plugin.

import rulebook from './rulebook';
import { usePowerRuntime } from './usePowerRuntime';

const powerVariant = {
  id: 'power',
  name: 'Power Chess',
  tagline: 'Every piece type has an RPG ability on a cooldown. Time your powers.',
  icon: '⚡',
  accent: 'from-yellow-600 to-amber-700',
  supportedGameTypes: ['ai', 'local'],
  order: 5,
  rulebook,
  useRuntime: usePowerRuntime,
};

export default powerVariant;
